import { getCookie, setCookie } from 'lib/tools/cookies'
import axios from 'axios'
import { inMiniProgramWebview } from 'utils/tool.js'

const prefix = `https://m.xinli001.com/`

// 咨询下单验证
export const contactPermit = user_id =>
  axios.post(`${prefix}user_home/consult_order_check`, {
    user_id
  })

export default {
  computed: {
    __isLogin() {
      return this.$store.getters.isLogin
    }
  },
  methods: {
    mixinSetCookie() {
      if (this.$isServer) return
      // #2319 【咨询】内部渠道标识优化
      const { channel_flag, cid, channel_id } = this.$route.query

      if (channel_flag) {
        setCookie({
          key: 'zixun_channel_flag',
          value: channel_flag,
          timeMinSec: 24 * 60 * 60 * 1000,
          domain: document.domain.split('.').slice(-2).join('.')
        })
      }

      if (cid || channel_id) {
        setCookie({
          key: 'consult_cooperation_channel',
          value: cid || channel_id,
          timeMinSec: 24 * 60 * 60 * 1000,
          domain: document.domain.split('.').slice(-2).join('.')
        })
      }
    },
    // 去咨询下单页
    async mixinToZxOrder(query) {
      // app内需要登陆
      if (
        this.$platform.isYixinliApp ||
        this.$platform.isZiXunApp ||
        inMiniProgramWebview()
      ) {
        await this.$store.dispatch('getUserInfo')
        if (!this.__isLogin) {
          this.toLogin()
          return
        }
      }

      if (query.way === 'pre') {
        query.way = ''
        query.activity_id = 41
      }

      const cookieKey = 'zixun_channel_flag'
      query.channel_flag =
        this.$route.query.channel_flag || getCookie(cookieKey) || ''
      query.activity_id =
        query.activity_id || this.$route.query.activity_id || ''
      query.coupon_id = query.coupon_id || this.$route.query.coupon_id || ''

      const lessonId = query.lesson_id || this.$route.query.lesson_id || ''
      if (lessonId) {
        query.lesson_id = lessonId
      }

      const keshiId = query.keshi_id || this.$route.query.keshi_id || ''
      if (keshiId) {
        query.keshi_id = keshiId
      }

      const toOrder = () => {
        this.routerPush(
          {
            path: '/consult-order-page',
            query
          },
          `https://static.xinli001.com/msite/index.html`,
          true,
          'hash',
          true
        )
      }

      const loading = this.$loading('正在获取咨询师状态')
      try {
        const isCanToOrder = await this.__checkoutCanToOrder(query.to_user_id)
        loading.close()
        if (isCanToOrder) {
          toOrder()
        }
      } catch (err) {
        loading.close()
        console.log(err)
        this.$toast({
          text: '网络异常，请稍后重试',
          zIndexTop: true
        })
      }
    },
    // 咨询下单验证
    async __checkoutCanToOrder(to_user_id) {
      const { code, message } = await contactPermit(to_user_id)
      if (code == 0) {
        return true
      } else {
        this.$toast({
          text: message,
          zIndexTop: true
        })
        return false
      }
    }
  }
}
